import { createSlice } from "@reduxjs/toolkit";
import {
  TOGGLE_SIDE_MENU,
  LIKE_DISLIKE_PAIR,
  SET_BROWSER_HISTORY
} from "../types/menuBar";

const initialState = {
  toggleMenu: false,
  liked: '',
  isBrowserHistoryActive: false
};

const MenuBar = createSlice({
  name: "menuBar",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(TOGGLE_SIDE_MENU, (state, { payload }) => {
      state.toggleMenu = payload;
    });
    builder.addCase(LIKE_DISLIKE_PAIR, (state, { payload }) => {
      state.liked = payload;
    });
    builder.addCase(SET_BROWSER_HISTORY, (state, { payload }) => {
      state.isBrowserHistoryActive = payload;
    });
  },
});

export const menuBar = MenuBar.reducer;
